import { tallyTokens } from "../../theme.tsx";
import * as React from "react";
import {
  Box,
  Grid,
  InputLabel,
  IconButton,
  Tooltip,
  useTheme,
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import store from "../../store/index-store.tsx";
import { markNotificationRead } from "../../store/notifications.tsx";
import { Trans } from "@lingui/react/macro";
import AvatarPanel from "../conversation/AvatarPanel.tsx";
import CustomReactMarkDown from "../../utils/markdown-wrapper.tsx";

interface NotificationProps {
  children?: React.ReactNode;
  content: string;
  id: string;
  read: boolean;
}

const Notification: React.FC<NotificationProps> = (props) => {
  const dispatch = store.dispatch;
  const theme = useTheme();

  const handleMarkRead = async () => {
    if (!props.read) {
      dispatch(markNotificationRead(props.id) as any);
    }
  };
  return (
    <Box marginBottom={"4%"} marginLeft={"5%"}>
      <Grid
        container
        direction="row"
        spacing={2}
        alignContent="flex-start"
        alignItems="flex-start"
      >
        <Grid
          size={{ xs: 1, lg: 1 }}
          sx={{
            marginTop: 0,
          }}
        >
          <Grid
            size={{ xs: 1, lg: 1 }}
            sx={{
              marginLeft: { xs: "0%", md: "15%", lg: "5%", xl: "25%" },
              marginTop: { xs: "0%", md: "0%", lg: "0%", xl: "0%" },
            }}
          >
            <AvatarPanel />
          </Grid>
        </Grid>
        <Grid size={{ xs: 11, lg: 11 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
            }}
          >
            <Box
              sx={{
                whiteSpace: "normal",
                backgroundColor: "transparent",
                color: "inherit",
                borderRadius: 0,
                padding: 0,
                maxWidth: "100%",
                display: "inline-block",
                marginLeft: "0%",
                marginRight: "10%",
                marginTop: { xs: "2px", lg: "3px", xl: "4px" },
              }}
            >
              <InputLabel
                sx={{
                  color: tallyTokens.ink,
                  whiteSpace: "normal",
                  margin: 0,
                }}
              >
                <CustomReactMarkDown content={props.content} compact />
              </InputLabel>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              marginTop: 0,
            }}
          >
            <Tooltip
              title={
                <Trans
                  context={
                    "Title of a button which allows the user to mark the notification as read."
                  }
                >
                  Mark as read
                </Trans>
              }
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    fontSize: "0.9rem",
                  },
                },
              }}
            >
              <span>
                <IconButton
                  onClick={handleMarkRead}
                  size="small"
                  disabled={props.read}
                >
                  {props.read ? (
                    <VisibilityIcon
                      fontSize="small"
                      style={{ color: theme.palette.primary.main }}
                    />
                  ) : (
                    <VisibilityOutlinedIcon fontSize="small" />
                  )}
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Notification;
